module.exports = __webpack_public_path__ + "assets/img/img247.9242935e.png";